import React from 'react';

const Arabic = () => {
  return (
    <div>
      Arabic
      Arabic
    </div>
  );
}

export default Arabic;
